export const ORDER_FORM_ANCHOR_ID = "order-form";

export function scrollToOrderForm(): boolean {
  const orderFormElement = document.getElementById(ORDER_FORM_ANCHOR_ID);
  if (!orderFormElement) {
    return false;
  }

  orderFormElement.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
}
